// Confirmation dialog handler – replaces Rails UJS data-confirm
// with the reusable Bootstrap modal from shared/_confirm_dialog.html.erb.
//
// Usage in views:
//   <%= link_to record, method: :delete,
//       data: { confirm_title: "Delete community",
//               confirm_body: "This will permanently remove My Community." } %>
//
// Falls back to the native confirm() if no dialog is available.

import * as bootstrap from "bootstrap";

(function () {
  'use strict';

  var dialogElement = document.getElementById('confirmation-dialog');
  if (!dialogElement) return;

  var bsModal = new bootstrap.Modal(dialogElement, { backdrop: true });

  var titleEl = document.getElementById('confirmationDialogLabel');
  var bodyEl = document.getElementById('confirmationDialogBody');
  var cancelBtn = document.getElementById('confirmationDialogCancel');
  var confirmBtn = document.getElementById('confirmationDialogConfirm');

  // The link that triggered the dialog (for focus return and firing the delete).
  var triggerLink = null;

  /* ------------------------------------------------------------------ */
  // Public helpers
  /* ------------------------------------------------------------------ */

  function showDialog(title, body, link) {
    triggerLink = link;
    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.textContent = body;

    resetButtonStates();
    try {
      bsModal.show();
      // Store reference for debugging
      dialogElement.__bsModalInstance = bsModal;
      window.__bbModalLastClick = { title: title, time: Date.now() };
    } catch (err) {
      if (window.__jsError) window.__jsError = 'showDialog: ' + err.message;
      else window.__jsError = 'showDialog: ' + err.message;
      // Fallback to native confirm
      if (confirm(title)) {
        link.click();
      }
    }
  }

  function hideDialog() {
    bsModal.hide();
    triggerLink = null;
  }

  function resetButtonStates() {
    if (cancelBtn) {
      cancelBtn.disabled = false;
      cancelBtn.textContent = 'Cancel';
    }
    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Delete';
    }
  }

  /* ------------------------------------------------------------------ */
  // Button interactions
  /* ------------------------------------------------------------------ */

  if (cancelBtn) {
    cancelBtn.addEventListener('click', function () {
      hideDialog();
      if (triggerLink) triggerLink.focus();
    });
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (!triggerLink) return;

      // Show "Deleting…" on both buttons while request is pending.
      if (cancelBtn) {
        cancelBtn.disabled = true;
        cancelBtn.textContent = 'Deleting...';
      }
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Deleting...';

      // Programmatically click the link so Rails UJS handles the DELETE
      // request exactly as it normally would. Strip the marker attribute
      // first so this click doesn't re-match onConfirmClick and reopen us.
      triggerLink.removeAttribute('data-confirm-title');
      triggerLink.click();
    });
  }

  // Return focus to the trigger link when the modal closes via
  // Esc, backdrop click, or X button.
  dialogElement.addEventListener('hidden.bs.modal', function () {
    if (triggerLink) triggerLink.focus();
    triggerLink = null;
  });

  /* ------------------------------------------------------------------ */
  // Global click handler – intercept [data-confirm-title] links
  /* ------------------------------------------------------------------ */

  function onConfirmClick(event) {
    var link = event.target.closest('[data-confirm-title]');
    if (!link) return;

    event.preventDefault();
    // stopPropagation alone doesn't stop Rails UJS's own click handler, which
    // is bound to document too — without this the delete fires either way.
    event.stopImmediatePropagation();

    var title = link.getAttribute('data-confirm-title') || 'Delete';
    var body = link.getAttribute('data-confirm-body') || 'Are you sure?';

    showDialog(title, body, link);
  }

  // Prevent double-firing on links that might also trigger other handlers.
  document.addEventListener('click', onConfirmClick, false);

})();
